import { useMutation, useLazyQuery } from "@apollo/client";
import { CREATE_ERRORS, GET_ERRORREPORTS } from "../../core/services/mutations";

export const useErrorsLog = () => {
  const [createErrors] = useMutation(CREATE_ERRORS, {
    fetchPolicy: "network-only",
    onError: () => {},
  });

  const createErrorLog = (error, endpoint, userId, orgId, screenName) => {
    const variables = {
      input: {
        errorMessage: error.message,
        endpoint: endpoint,
        userId: userId,
        orgId: orgId,
        screenName: screenName,
      },
    };
    createErrors({ variables }).catch(() => {});
    return null;
  };
  const [getallErrors, { data: allerrorsData, loading: allerrorsLoading }] =
    useLazyQuery(GET_ERRORREPORTS, {});
  return { createErrorLog, getallErrors, allerrorsData, allerrorsLoading };
};
